var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alerts-container"},[_vm._t("default",null,{"clicked":_vm.openModal}),_c('CreateAccountModalForm',{attrs:{"filtersWord":_vm.filtersWord,"removeFilterItem":_vm.removeFilterItem,"filterFields":_vm.filterFields}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }